/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'sv',
  Pagination: {
    items_per_page: '/ sida',
    jump_to: 'Gå till',
    jump_to_confirm: 'bekräfta',
    page: '',
    prev_page: 'Föreg sida',
    next_page: 'Nästa sida',
    prev_5: 'Föreg 5 sidor',
    next_5: 'Nästa 5 sidor',
    prev_3: 'Föreg 3 sidor',
    next_3: 'Nästa 3 sidor'
  },
  DatePicker: {
    lang: {
      placeholder: 'Välj datum',
      rangePlaceholder: ['Startdatum', 'Slutdatum'],
      locale: 'sv_SE',
      today: 'I dag',
      now: 'Nu',
      backToToday: 'Till idag',
      ok: 'Ok',
      clear: 'Avbryt',
      month: 'Månad',
      year: 'År',
      timeSelect: 'Välj tidpunkt',
      dateSelect: 'Välj datum',
      monthSelect: 'Välj månad',
      yearSelect: 'Välj år',
      decadeSelect: 'Välj årtionde',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY-MM-DD',
      dayFormat: 'D',
      dateTimeFormat: 'YYYY-MM-DD H:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Förra månaden (PageUp)',
      nextMonth: 'Nästa månad (PageDown)',
      previousYear: 'Föreg år (Control + left)',
      nextYear: 'Nästa år (Control + right)',
      previousDecade: 'Föreg årtionde',
      nextDecade: 'Nästa årtionde',
      previousCentury: 'Föreg århundrade',
      nextCentury: 'Nästa århundrade'
    },
    timePickerLocale: {
      placeholder: 'Välj tid'
    }
  },
  TimePicker: {
    placeholder: 'Välj tid'
  },
  Calendar: {
    lang: {
      placeholder: 'Välj datum',
      rangePlaceholder: ['Startdatum', 'Slutdatum'],
      locale: 'sv_SE',
      today: 'I dag',
      now: 'Nu',
      backToToday: 'Till idag',
      ok: 'Ok',
      clear: 'Avbryt',
      month: 'Månad',
      year: 'År',
      timeSelect: 'Välj tidpunkt',
      dateSelect: 'Välj datum',
      monthSelect: 'Välj månad',
      yearSelect: 'Välj år',
      decadeSelect: 'Välj årtionde',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY-MM-DD',
      dayFormat: 'D',
      dateTimeFormat: 'YYYY-MM-DD H:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Förra månaden (PageUp)',
      nextMonth: 'Nästa månad (PageDown)',
      previousYear: 'Föreg år (Control + left)',
      nextYear: 'Nästa år (Control + right)',
      previousDecade: 'Föreg årtionde',
      nextDecade: 'Nästa årtionde',
      previousCentury: 'Föreg århundrade',
      nextCentury: 'Nästa århundrade'
    },
    timePickerLocale: {
      placeholder: 'Välj tid'
    }
  },
  Table: {
    filterTitle: 'Filtermeny',
    filterConfirm: 'OK',
    filterReset: 'Rensa'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Avbryt',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Avbryt'
  },
  Transfer: {
    searchPlaceholder: 'Sök',
    itemUnit: 'element',
    itemsUnit: 'element'
  },
  Empty: {
    description: 'Ingen information'
  },
  Text: {
    edit: 'editera',
    copy: 'kopiera',
    copied: 'kopierad',
    expand: 'expandera'
  },
  Upload: {
    uploading: 'Uppladdning...',
    removeFile: 'Ta bort fil',
    uploadError: 'Uppladdningsfel',
    previewFile: 'Förhandsgranska filen',
    downloadFile: 'Nedladdning fil'
  }
};
